/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const FormalEvaluation = {

	delete (context, formalEvaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/formal-evaluation"
			+ "?formalEvaluationId=" + formalEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, formalEvaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/formal-evaluation"
			+ "?formalEvaluationId=" + formalEvaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/formal-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/formal-evaluation/contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCommitteeUsers (context, offerId, committeeUserIds, onSuccess, onError, options) {
		Api.post(context,
			"/formal-evaluation/committee-users"
			+ "?offerId=" + offerId
			, committeeUserIds
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, formalEvaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/formal-evaluation"
			+ "?formalEvaluationId=" + formalEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, evaluationId, correctionCauseDTO, onSuccess, onError, options) {
		Api.put(context,
			"/formal-evaluation/correction"
			+ "?evaluationId=" + evaluationId
			, correctionCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, formalEvaluationId, formalEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/formal-evaluation/data"
			+ "?formalEvaluationId=" + formalEvaluationId
			, formalEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, formalEvaluationId, formalEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/formal-evaluation/finish"
			+ "?formalEvaluationId=" + formalEvaluationId
			, formalEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
